<template>
  <div class="section" v-if="error">
    <div class="toast toast--error">
      <button class="btn-close" v-on:click="close"></button>
      <h6>{{ error.label }}</h6>
      <div>
        <span v-html="error.message"></span>
      </div>
    </div>
  </div>
</template>
<script>
module.exports = {
  name: "server-error",
  props: {
    error: {}
  },
  methods: {
    close() {
      this.$store.commit("core/setError", { serverError: "" });
    }
  }
};
</script>
